module.exports = __webpack_public_path__ + "img/flespompoen-op-bakplaat.2657dcc5.jpeg";